import * as types from './mutations-types'
import certificationApi from '../../../../../api/wx-member/go-out-management/certification-audit/certification-audit'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'

export default {
  searchCustomerByCondition: ({commit}, data) => {
    certificationApi.searchCustomerByCondition(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'verificationStatus',
            fieldPropName: 'verificationStatusName',
            fieldFormatParam: DictionaryConstants.MEMBER_VERIFICATION_STATUS
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'verificationManner',
            fieldPropName: 'verificationMannerName',
            fieldFormatParam: DictionaryConstants.MEMBER_MEMBER_SOURCE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DATE,
            fieldPropCode: 'verificationBeginTime',
            fieldPropName: 'verificationBeginTime',
            fieldFormatParam: 'YYYY/MM/DD'
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
          commit(types.MEMBER_INFO_DATA, res)
        })
      })
  },
  auditingCustomerById: ({commit, state}, data) => {
    return new Promise(resolve => {
      certificationApi.auditingCustomerById(data)
        .then(res => {
          resolve(res)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/certification-audit/store/actions.js